import { NgOptimizedImage } from '@angular/common';
import { Component, Input } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-logo',
  imports: [NgOptimizedImage],
  templateUrl: './logo.html',
  styleUrl: './logo.scss',
})
export class Logo {
  @Input() size: number = 40;

  get appname(): string {
    return environment.appname;
  }
}
